import { render, staticRenderFns } from "./AttendedAppointments.vue?vue&type=template&id=336646f0&scoped=true&"
import script from "./AttendedAppointments.vue?vue&type=script&lang=js&"
export * from "./AttendedAppointments.vue?vue&type=script&lang=js&"
import style0 from "./AttendedAppointments.vue?vue&type=style&index=0&id=336646f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336646f0",
  null
  
)

export default component.exports